import React, { useState, useEffect } from "react";
import NavigationBar from "../ReusableComp/NavigationBar";
import NavBarLeft from "../ReusableComp/NavBarLeft";
import { useDispatch, useSelector } from "react-redux";
import {
  getZoneData,
  getMhStudiesSites,
  getMhStudies,
  getStudyData,
} from "../../Redux/actions/actions";
import axios from "../../axios-interceptor";
import { base_url } from "../../utilities";
import PopUpModal from "../ReusableComp/PopUpModal";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import { useNavigate } from "react-router";
import { Container, Stack } from "react-bootstrap";
import { MarketingHeadFlow } from "../ReusableComp/NavBarLeft";
import moment from "moment";
import Loader from '../ReusableComp/Loader'; // Import the Loader component


const MarketingHeadAddStaff = () => {
  const navigate = useNavigate();
  useEffect(() => {
    if (!localStorage.getItem("login_user_name")) {
      navigate("/");
    }
  }, []);
  const dispatch = useDispatch();

  const [open, setOpen] = React.useState(false);

  const mhStudies = useSelector((state) => state.mhStudies);
  const mhStudiesSites = useSelector((state) => state.mhStudiesSites);
  const mhfStates = useSelector((state) => state.mhfStates);
  const mhfCities = useSelector((state) => state.mhfCities);
  const mhfSites = useSelector((state) => state.mhfSites);
  const mhfStudies = useSelector((state) => state.mhfStudies);
  const [fcitiesList, setFCitiesList] = useState([]);
  const [fSitesList, setFSitesList] = useState([])

  const [selectedOptions, setSelectedOptions] = useState([]);

  const [studyIds, setStudyIds] = useState([]);
  const [studyInfo, setStudyInfo] = useState([]);

  const [fstate, setFState] = useState("");
  const [fcity, setFCity] = useState("");
  const [fsite, setFSite] = useState("");
  const [fStudy, setFStudy] = useState("");
  const [loading, setLoading] = useState(false);
  
  useEffect(() => {
    dispatch(getZoneData());
    dispatch(getStudyData());
    dispatch(
      getMhStudies({
        mh_id: localStorage.getItem("mh_id"),
      })
    );
  }, [dispatch]);
  const sampar = [];

  const handleChange = (selected) => {
    selected.map((item) => {
      sampar.push(item.value);
    });
    setSelectedOptions(selected);
    setStudyIds(sampar);
    const filteredJsonList = mhStudies.filter((json) =>
      sampar.includes(json.study_id)
    );
    setStudyInfo(filteredJsonList);
  };

  const handleClosePopup = () => {
    setOpen(false);
    window.location.reload();
  };

  const createNewPI = () => {
    const extractedData = selectedItems.map((item) => ({
      study_id: item.study_id,
      site_id: item.site_id,
      pi_id: item.pi_id,
    }));
    let marketing_staff_object = {
      mh_id: localStorage.getItem("mh_id"),
      marketing_staff_name: mrName,
      email: mrEmail,
      date_of_birth: mrDateOfBirth,
      phone_number: mrContactNumber,
      sex: mrGender,
      date_of_joining: mrDateOfJoining,
      mapping_ids: extractedData,
    };
    setLoading(true);

    axios
      .post(
        base_url + "marketing-staff/create_marketing_staff",
        marketing_staff_object
      )
      .then((res) => {
        setLoading(false);
        if (res.data.data.errors) {
          if (res.data.data.errors[0].message === "email must be unique") {
            toast.error(
              "The user has already been created with the given email.",
              {
                toastId: 1,
              }
            );
          }
        } else {
          setLoading(false);
          setOpen(true);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const [mrName, setmarketingHeadName] = useState("");
  const handlemarketingHeadNameChange = (event) => {
    const inputValue = event.target.value;
    const regex = /^[A-Za-z\s.]+$/; // Only alphabetic characters allowed

    if (regex.test(inputValue) || inputValue === "") {
      setmarketingHeadName(event.target.value);
    }
  };
  const [mrEmail, setmarketingHeadEmail] = useState("");

  const viewProfile = () => {
    window.location.replace("/marketingstafflist");
  };

  const [regStep, setRegStep] = useState(1);

  const registrationSteps = [
    {
      stepTitle: "1. Staff Details",
      description: "Name, Email & Phone",
    },
    {
      stepTitle: "2. Study & Dose Details",
      description: "Study Information",
    },
    {
      stepTitle: "3. Mapping",
      description: "Assign site, Principal Investigator Details",
    },
    {
      stepTitle: "4. Preview and Confirm",
      description: "Final confirmation to register staff",
    },
  ];

  const handleClearFilters = () => {
    // Reset all filter values here
    setFState("");
    setFCity("");
    setFSite("");
    setFStudy("");
    setFCitiesList([]);
    setFSitesList([]);
    setFStudyList([])
    setFilteredData([]);
  };

  const handleStepChange = (val) => {
    if (regStep === 2) {
      dispatch(
        getMhStudiesSites({
          study_id: studyIds,
          zone_id: localStorage.getItem("mh_zone_id"),
        })
      );
    }
    if (val > 0 && regStep < 4) {
      let shift = regStep + val;
      setRegStep(shift);
    }
    if (val < 0 && regStep > 1) {
      let shift = regStep + val;
      setRegStep(shift);
    }
  };
  const [ispiEmailValid, setIsPiEmailValid] = useState(true);

  function handleBlur() {
    setIsPiEmailValid(validateEmail(mrEmail));
  }
  const validateEmail = (email) => {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    return regex.test(email);
  };
  
  const handleStudyChange = () => {};
  const [mrContactNumber, setMrContactNumber] = useState("");
  const [phoneSatisfied, setPhoneSatisfied] = useState(false);

  const handlePhonenumber = (e) => {
    let value = e.target.value;

    setMrContactNumber(value.length > 10 ? value.slice(0, 10) : value);
    setPhoneSatisfied(value.length >= 10 ? false : true);
  };

  const [mrGender, setQrGender] = useState("");
  const [mrDateOfBirth, setQrDateOfBirth] = useState("");
  const [mrAge, setQrAge] = useState("");
  const maxDate = new Date().toISOString().split("T")[0];
  const handleQrGenderChange = (val) => {
    setQrGender(val);
  };
  const handleQrEmailChange = (event) => {
    // setmarketingHeadEmail(event.target.value);
       const input = event.target;
        const isValid = input.checkValidity();
        setIsPiEmailValid(isValid);
        setmarketingHeadEmail(input.value);
  };

  const handleQrDateOfBirthChange = (event) => {
    setQrDateOfBirth(event.target.value);
    calculateAge(event.target.value);
  };

  const today = new Date();
  const calculateAge = (dateOfBirth) => {
    const birthDate = new Date(dateOfBirth);
    let calculatedAge = today.getFullYear() - birthDate.getFullYear();

    // Check if the birthday hasn't occurred yet this year
    if (
      today.getMonth() < birthDate.getMonth() ||
      (today.getMonth() === birthDate.getMonth() &&
        today.getDate() < birthDate.getDate())
    ) {
      calculatedAge--;
    }

    setQrAge(calculatedAge);
  };
  const [selectedItems, setSelectedItems] = useState([]);

  const handleCheckBox = (item) => {
    if (
      selectedItems.some(
        (selectedItem) => selectedItem.site_name === item.site_name
        && selectedItem.study_name === item.study_name
        && selectedItem.name === item.name
      )
    ) {
      setSelectedItems((prevItems) =>
        prevItems.filter(
          (selectedItem) => (selectedItem.site_name !== item.site_name || selectedItem.study_name !== item.study_name || selectedItem.name !== item.name)
        )
      );
    } else {
      setSelectedItems((prevItems) => [...prevItems, item]);
    }
  };

  const [mrDateOfJoining, setMrDateOfJoining] = useState("");

  const onChnageDateOfJoining = (e) => {
    setMrDateOfJoining(e.target.value);
  };

  const [filteredData, setFilteredData] = useState([]);
  const handleStateChnage = (e) => {
    if(e.target.value ===""){
      setFState(e.target.value);
      setFCitiesList([])
      setFSitesList([])
      setFStudyList([])
      setFCity("")
      setFSite("")
      setFStudy("")
      setFilteredData(mhStudiesSites)
    }
    else{
      setFCitiesList([])
      setFSitesList([])
      setFStudyList([])
      setFCity("")
      setFSite("")
      setFStudy("")
      setFState(e.target.value);
      const filteredData = mhStudiesSites.filter(
        (item) =>
          item.state_name.includes(e.target.value) &&
          item.city_name.includes(fcity) &&
          item.site_name.includes(fsite) &&
          item.study_name.includes(fStudy)
      );
      setFilteredData(filteredData);
      // ==============================
      // Filter the data based on the selected state
      const filteredDataByState = mhStudiesSites.filter(
        (item) => item.state_name === e.target.value
      );
  
      // Extract unique cities from the filtered data
      const uniqueCities = [...new Set(filteredDataByState.map(item => item.city_name))];
  
      // Now you can do whatever you want with the uniqueCities list, such as setting it in a state variable
      setFCitiesList(uniqueCities);

    }
    
  };

  const handleCityChnage = (e) => {

    if(e.target.value ===""){
      setFCity(e.target.value);
      setFSitesList([])
      setFStudyList([])
      setFSite("")
      setFStudy("")
    }
    else{
      setFSitesList([])
      setFStudyList([])
      setFSite("")
      setFStudy("")
      setFCity(e.target.value);

    const filteredData = mhStudiesSites.filter(
      (item) =>
        item.state_name.includes(fstate) &&
        item.city_name.includes(e.target.value) &&
        item.site_name.includes(fsite) &&
        item.study_name.includes(fStudy)
    );
    setFilteredData(filteredData);
    // ==========================
    const filteredDataByState = mhStudiesSites.filter(
      (item) => item.city_name === e.target.value
    );

    // Extract unique cities from the filtered data
    const uniqueCSites = [...new Set(filteredDataByState.map(item => item.site_name))];

    // Now you can do whatever you want with the uniqueCities list, such as setting it in a state variable
    setFSitesList(uniqueCSites);


    }

    
  };
  const [fStudyList, setFStudyList] = useState([])
  const handleSiteChnage = (e) => {

    if(e.target.value ===""){
      setFSite(e.target.value);
      setFStudyList([])
      setFStudy("")
    }
    else{
      setFStudyList([])
      setFStudy("")
      setFSite(e.target.value);
    const filteredData = mhStudiesSites.filter(
      (item) =>
        item.state_name.includes(fstate) &&
        item.city_name.includes(fcity) &&
        item.site_name.includes(e.target.value) &&
        item.study_name.includes(fStudy)
    );
    setFilteredData(filteredData);
     // ==========================
     const filteredDataByState = mhStudiesSites.filter(
      (item) => item.site_name === e.target.value
    );

    // Extract unique cities from the filtered data
    const uniqueStudies = [...new Set(filteredDataByState.map(item => item.study_name))];

    // Now you can do whatever you want with the uniqueCities list, such as setting it in a state variable
    setFStudyList(uniqueStudies);

    }
    
  };

  const handleStudyChnage = (e) => {
    setFStudy(e.target.value);
    const filteredData = mhStudiesSites.filter(
      (item) =>
        item.state_name.includes(fstate) &&
        item.city_name.includes(fcity) &&
        item.site_name.includes(fsite) &&
        item.study_name.includes(e.target.value)
    );
    setFilteredData(filteredData);
  };

  function convertToTitleCase(str) {
    return str.replace(/\w\S*/g, function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
}
  return (
    <>
    <div>
      <NavigationBar
        title={"Add Marketing Staff"}
        handleFilteredData={handleStudyChange}
        studyDropdwn={true}
      />
      {/* <MarketingHeadFlow /> */}
      <div className="main_body registration_steps_main">
        <div className="row flex-nowrap">
          <div className="col-lg-3 pi_left_content_main">
            <div className="lableSteps">
              <span>Registration Steps</span>
            </div>

            <div className="pmsaddpireg">
              {registrationSteps?.map((step, index) => {
                return (
                  <div
                    className={`my-div ${
                      regStep === index + 1
                        ? "registration_steps_selected"
                        : "registration_steps"
                    }`}
                    key={index}
                  >
                    <span>{step.stepTitle}</span>
                    <span className="registration_description">
                      {step.description}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="col">
            <div className="lableContent">
              <span>{registrationSteps[regStep - 1].stepTitle}</span>
              <span>{regStep} of 4</span>
            </div>

            {/* PI Details inputs */}
            {regStep === 1 && (
              <div className="med_rev_1st">
                <div className="piDetilsRow">
                  <div className="piDetilsItems">
                    <label for="mrName">
                      Name<span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      value={mrName}
                      className="customInput"
                      id="mrName"
                      type="text"
                      placeholder="Full Name"
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "16px 12px", width: "380px" }}
                      onChange={handlemarketingHeadNameChange}
                    />
                  </div>

                  <div className="piDetilsItems">
                    <label for="mrDateOfBirth">
                      Date of Birth<span style={{ color: "red" }}>*</span>
                    </label>
                    <div
                      className="dob_group"
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <input
                        style={{
                          borderRadius: "6px 0px 0px 6px",
                          padding: "16px 12px",
                          width: "290px",
                          cursor: "not-allowed",
                        }}
                        value={mrDateOfBirth}
                        max={maxDate}
                        className="customInput"
                        id="mrDateOfBirth"
                        type="date"
                        aria-placeholder="#D4D4D4"
                        onKeyDown={(e) => e.preventDefault()}
                        onChange={handleQrDateOfBirthChange}
                      />
                      <input
                        style={{
                          borderRadius: "0px 6px 6px 0px",
                          padding: "16px 12px",
                          width: "88px",
                        }}
                        value={mrAge}
                        className="customInput_dob"
                        id="mrAge"
                        type="number"
                        placeholder="Age"
                        aria-placeholder="#D4D4D4"
                        disabled
                        // onChange={handleQrAgeChange}
                      />
                    </div>
                  </div>




                </div>

                <div className="piDetilsRow">
                  <div className="piDetilsItems">
                    <label for="mrContactNumber">
                      Phone<span style={{ color: "red" }}>*</span>
                    </label>
                    <div className='d-flex'>

                    <input
                        value={"+91"}
                        className=" country_code"
                        placeholder="+91"
                        aria-placeholder="#D4D4D4"
                        style={{
                        // padding: "16px 12px",
                        width: "50px",
                        borderRadius: "8px 0px 0px 8px",
                        backgroundColor: "#F7F9FB",
                        }}
                        disabled                            
                      />
                    <input
                      value={mrContactNumber}
                      className="customInput noSpinArrows"
                      id="mrContactNumber"
                      type="number"
                      placeholder="9849762697"
                      maxLength={10}
                      aria-placeholder="#D4D4D4"
                      style={{ padding: "16px 12px", width: "330px" ,borderRadius:"0px 8px 8px 0px"}}
                      // onChange={handleQrContactNumberChange}
                      onChange={handlePhonenumber}
                      min="0"
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/[^\d\s]/g, ''); // Allow only positive integers and spaces
                      }}
                    />
                    </div>
                    {phoneSatisfied && (
                      <p style={{ fontSize: "smaller", color: "#d14141" }}>
                        * Must be 10 digits{" "}
                      </p>
                    )}
                  </div>
                  <div className="piDetilsItems">
                    <label for="mrGender">
                      Sex<span style={{ color: "red" }}>*</span>
                    </label>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <button
                        onClick={() => handleQrGenderChange("Male")}
                        className={`${
                          mrGender === "Male"
                            ? "genderButtonSelected"
                            : "genderButton"
                        }`}
                        style={{ borderRadius: "6px 0px 0px 6px" }}
                      >
                        Male
                      </button>
                      <button
                        onClick={() => handleQrGenderChange("Female")}
                        className={`${
                          mrGender === "Female"
                            ? "genderButtonSelected"
                            : "genderButton"
                        }`}
                      >
                        Female
                      </button>
                      <button
                        onClick={() => handleQrGenderChange("Others")}
                        className={`${
                          mrGender === "Others"
                            ? "genderButtonSelected"
                            : "genderButton"
                        }`}
                        style={{ borderRadius: "0px 6px 6px 0px" }}
                      >
                        Others
                      </button>
                    </div>
                  </div>
                </div>

                <div className="piDetilsRow">
                          <div className='piDetilsItems '>
                            <label htmlFor="piEmail">Email<span style={{ color: "red" }}>*</span></label>
                            <input
                              className="customInput"
                              value={mrEmail}
                              id='piEmail'
                              type='email'
                              name='piEmail'
                              placeholder='email@gmail.com'
                              aria-placeholder='#D4D4D4'
                              style={{ padding: "16px 12px", width: "380px" }}
                              pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                              required
                              onChange={handleQrEmailChange}
                              />              
                              {!ispiEmailValid && <p className='errormsg' >Invalid email format</p>}
                          </div>

 <div className="piDetilsItems">
                    <label for="mrcNumber">Date of joining</label>
                    <input
                      value={mrDateOfJoining}
                      className="customInput"
                      id="mrcNumber"
                      type="date"
                      placeholder="Enter Here"
                      aria-placeholder="#D4D4D4"
                      style={{
                        padding: "16px 12px",
                        width: "380px",
                        cursor: "not-allowed",
                      }}
                      onChange={onChnageDateOfJoining}
                      onKeyDown={(e) => e.preventDefault()}
                    />
                  </div>
               
                </div>
              </div>
            )}
            {/* Study and Dose Details */}
            {regStep === 2 && (
              <div className="piRegPrev">
                <div
                  style={{
                    margin: "32px 20px",
                    display: "flex",
                    flexDirection: "column",
                    textAlign: "start",
                  }}
                >
                  <label htmlFor="piStudy">
                    Select Study<span className="text-danger">*</span>
                  </label>

                  <Select
                    id="piStudy"
                    isMulti
                    options={mhStudies?.map((item) => ({
                      value: item.study_id,
                      label: `${item.study_name}`,
                    }))}
                    value={selectedOptions}
                    onChange={handleChange}
                    placeholder="Select Study from the options"
                    // className="custom_select_main"
                  />
                </div>
                {studyInfo?.map((item) => {
                  return (
                    <div className="zoneInformationRows">
                      <div className="leftSide">
                        <h6>{item.study_name} </h6>
                        <div className="horizontalLine"></div>
                        <h6>No. of Doses: {item.number_of_doses}</h6>
                        <div className="horizontalLine"></div>
                      </div>
                      <div className="rightSide">
                        <div className="zoneCard">
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                            }}
                          >
                            <h6>
                              {moment(item.study_initiation_date).format(
                                "DD-MM-YYYY"
                              )}
                            </h6>
                            <img
                              src="./images/icons/startsCalender.svg"
                              alt=""
                            />
                          </div>
                          <div style={{ textAlign: "start" }}>
                            Study Initiation Date
                          </div>
                        </div>
                        <div className="zoneCard">
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                            }}
                          >
                            <h6>{item.estimated_sites}</h6>
                            <img src="./images/icons/pointer.svg" alt="" />
                          </div>
                          <div style={{ textAlign: "start" }}>
                            Estimated sites
                          </div>
                        </div>
                        <div className="zoneCard">
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                            }}
                          >
                            <h6>{item.estimated_subjects}</h6>
                            <img src="./images/icons/pointer.svg" alt="" />
                          </div>
                          <div style={{ textAlign: "start" }}>
                            Estimated subjects
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
            {/* Site Information */}
            {regStep === 3 && (
              <div className="piRegPrev">
                <Container fluid className="pt-4">
                  <Stack direction="horizontal" gap={3} className=" mb-4">
                    <div>
                      <select
                        className="selectItem"
                        onChange={handleStateChnage}
                        value={fstate}
                      >
                        <option value={""}>All States</option>
                        {mhfStates &&
                          mhfStates?.map((item) => {
                            return <option value={item}>{item}</option>;
                          })}
                      </select>
                    </div>
                    <div>
                      <select
                        className="selectItem"
                        onChange={handleCityChnage}
                        value={fcity}
                      >
                        <option value={""}>All Cities</option>
                        {fcitiesList &&
                          fcitiesList?.map((item) => {
                            return <option value={item}>{item}</option>;
                          })}
                      </select>
                    </div>
                    <div>
                      <select
                        className="selectItem"
                        onChange={handleSiteChnage}
                        value={fsite}
                      >
                        <option value={""}>All Sites</option>
                        {fSitesList &&
                          fSitesList?.map((item) => {
                            return <option value={item}>{item}</option>;
                          })}
                      </select>
                    </div>
                    <div>
                      <select
                        className="selectItem"
                        onChange={handleStudyChnage}
                        value={fStudy}
                      >
                        <option value={""}>All Studies</option>
                        {fStudyList &&
                          fStudyList?.map((item) => {
                            return <option value={item}>{item}</option>;
                          })}
                      </select>
                    </div>

                    <button className="orange_btn" onClick={handleClearFilters}>
                      Clear
                    </button>
                  </Stack>
                </Container>
                <div className="mapping">
                  {mhStudiesSites?.length === 0 ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "100%",
                      }}
                    >
                      <p> No Principal Investigator available for this zone </p>
                    </div>
                  ) : 
                  <div>
                  {filteredData?.length !== 0 ?
                  <div>
                    {filteredData?.map((item) => (
                      <div
                      className="mappringCard"
                      style={{ backgroundColor: "white" }}
                    >
                      <div className="mappingCardItem">
                        <input
                          style={{ width: "20px", height: "20px" }}
                          className="align-items-center C-pointer"
                          type="checkbox"
                          name="check_boxes"
                          checked={selectedItems.some(
                            (selectedItem) =>
                              selectedItem.site_name === item.site_name
                              &&
                              selectedItem.study_name === item.study_name
                              &&
                              selectedItem.name === item.name
                          )}
                          onChange={() => handleCheckBox(item)}
                        />
                      </div>
                      <div className="mappingCardItems">
                        <h6>{item.site_name}</h6>
                        <p>
                          {item.site_address}, {item.city_name},{" "}
                          {item.state_name}
                        </p>
                        <h6>Study Name: {item.study_name}</h6>  
                      </div>
                      <div className="mappingCardItems">
                        <h6>{item.name}</h6>

                        <p>{item.contact_number}</p>
                        
                        <p style={{ textAlign: "start" }}>
                          Principal Investigator
                        </p>
                      </div>
                      <div
                        className="mappingCardItem"
                        style={{
                          alignItems: "center",
                          justifyContent: "center",
                          marginBottom:"50px"
                        }}
                      >
                        <img
                          className=""
                          src="./images/icons/Telephone.svg"
                          alt="Telephone"
                        />
                      </div>
                    </div>
                    ))}
                  </div>
                  :
                  <div>
                    {mhStudiesSites?.map((item) => (
                      <div
                        className="mappringCard"
                        style={{ backgroundColor: "white" }}
                      >
                        <div className="mappingCardItem">
                          <input
                            style={{ width: "20px", height: "20px" }}
                            className="align-items-center C-pointer"
                            type="checkbox"
                            name="check_boxes"
                            checked={selectedItems.some(
                              (selectedItem) =>
                                selectedItem.site_name === item.site_name
                                &&
                                selectedItem.study_name === item.study_name
                                &&
                                selectedItem.name === item.name
                            )}
                            onChange={() => handleCheckBox(item)}
                          />
                        </div>
                        <div className="mappingCardItems">
                          <h6>{item.site_name}</h6>
                          <p>
                            {item.site_address}, {item.city_name},{" "}
                            {item.state_name}
                          </p>
                          <h6>Study Name: {item.study_name}</h6>  
                        </div>
                        <div className="mappingCardItems">
                          <h6>{item.name}</h6>

                          <p> +91 {item.contact_number}</p>
                          
                          <p style={{ textAlign: "start" }}>
                            Principal Investigator
                          </p>
                        </div>
                        <div
                          className="mappingCardItem"
                          style={{
                            alignItems: "center",
                            justifyContent: "center",
                            marginBottom:"50px"
                          }}
                        >
                          <img
                            className=""
                            src="./images/icons/Telephone.svg"
                            alt="Telephone"
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                }
                </div>
}
                </div>
              </div>
            )}

            {regStep === 4 && (
              <div className="piRegPrev">
                <div style={{ margin: "24px 32px" }}>
                  <p style={{ fontWeight: "bold", color: "black" }}>
                    Name: {mrName}
                  </p>
                  <p>{mrAge} Yrs</p>
                </div>
                <div
                  style={{
                    border: "1px dotted #E1E5E7",
                    marginLeft: "32px",
                    marginRight: "24px",
                  }}
                ></div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    margin: "24px 32px 0px 32px",
                    justifyContent: "space-evenly",
                  }}
                >
                  <p style={{ gap: "10px" }}>
                    {mrContactNumber}
                    <img
                      style={{ height: "20px", margin: "5px" }}
                      src="./images/icons/Phone Telephone by Streamlinehq (1).svg"
                      alt=""
                    />
                  </p>
                  <p>.</p>
                  <p style={{ gap: "10px" }}>
                    {mrEmail}
                    <img
                      style={{ height: "20px", margin: "5px" }}
                      src="./images/icons/Mail Send Envelope by Streamlinehqmainemail.svg"
                      alt=""
                    />
                  </p>
                  <p>.</p>

                  <p style={{ gap: "10px" }}>
                    {moment(mrDateOfBirth).format("DD-MM-YYYY")}
                    <img
                      style={{ height: "20px", margin: "5px" }}
                      src="./images/icons/Food Cake by Streamlinehq.svg"
                      alt=""
                    />
                  </p>
                </div>

                <div
                  style={{
                    border: "1px dotted #E1E5E7",
                    marginLeft: "32px",
                    marginRight: "32px",
                  }}
                ></div>
                {selectedItems?.map((item) => {
                  return (
                    <div className="previewSitesCard">
                      <div style={{ textAlign: "start" }}>
                        <h6>{item.study_name}</h6>
                      </div>
                      <div
                        className="horizontalLine"
                        style={{ width: "100%" }}
                      ></div>
                      <div className="previewBody">
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              alignItems: "center",
                              marginTop: "12px",
                              marginBottom: "12px",
                            }}
                          >
                            <span>{item.site_name}</span>
                            <img
                              src="./images/icons/location.svg"
                              alt="location"
                            />
                          </div>
                          <span className="bodyText">
                            {item.site_address}, {item.city_name},{" "}
                            {item.state_name}
                          </span>
                          <span className="bodyText">{item.phone_number}</span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          <div
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <span className="bodyText">{item.name}</span>
                            <span className="bodyText">
                              +91 {item.contact_number}
                            </span>
                            <span className="bodyText">
                              {"Principal Investigator"}
                            </span>
                          </div>
                          <div
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <img
                              src="./images/icons/Phone Telephone by Streamlinehq (1).svg"
                              alt="phone"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            <div className="registrationStepsFooter">
              {regStep > 1 && (
                <button
                  className="white_btn"
                  onClick={() => handleStepChange(-1)}
                >
                  Previous
                </button>
              )}
              {regStep === 1 && (
                <button
                  className="orange_btn"
                  onClick={() => handleStepChange(1)}
                  disabled={
                    !(
                      mrName !== "" &&
                      mrDateOfBirth !== "" &&
                      mrDateOfJoining !== "" &&
                      !phoneSatisfied &&
                      mrContactNumber !== "" &&
                      mrGender !== "" &&
                      mrEmail !== "" &&
                      ispiEmailValid
                    )
                  }
                >
                  Continue
                </button>
              )}
              {regStep === 2 && (
                <button
                  className="orange_btn"
                  onClick={() => handleStepChange(1)}
                  disabled={!(selectedOptions.length !== 0)}
                >
                  Continue
                </button>
              )}
              {regStep === 3 && (
                <button
                  className="orange_btn"
                  onClick={() => handleStepChange(1)}
                  disabled={!(selectedItems.length !== 0)}
                >
                  Continue
                </button>
              )}
              {regStep === 4 && (
                <button className="orange_btn" onClick={createNewPI}>
                  Done
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
      <PopUpModal
        handleClose={handleClosePopup}
        open={open}
        title={"Success!"}
        msg={convertToTitleCase(mrName) + "'s Marketing Staff profile has been created!"}
        close={"Close"}
        actionbtn={"Done"}
        onConfirm={viewProfile}
      />
    </div>
    {loading && <Loader />}
    </>

  );
};

export default MarketingHeadAddStaff;
